import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class PageTitleService {
    private readonly title = inject(Title);
    private readonly fallbackTitle = 'New page';

    public updateTitle(pageName: string | null | undefined, isPreview: boolean): void {
        if (isPreview) {
            return;
        }

        const normalizedTitle = (pageName ?? '').trim();
        this.title.setTitle(normalizedTitle.length > 0 ? normalizedTitle : this.fallbackTitle);
    }
}
